<template>
  <div>
    <!-- wifi开关 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title"
          >{{ $t("message.systemMsg.WiFiSettings") }}
        </span>
      </el-col>
      <el-col :span="24">
        <span class="secondfont-title">{{
          $t("message.systemMsg.WiFiSwitch")
        }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.WiFiSwitch") }}:</span>
        <el-select size="medium" v-model="w.io">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- wifi管理 -->
    <el-row>
      <el-col :span="24">
        <span class="secondfont-title">{{
          $t("message.systemMsg.WifiManagement")
        }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('message.systemMsg.RemoveAllWifi') }}:</span>
        <el-select size="medium" v-model="w.rw">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="24" class="tips-text">
        <span>{{ $t('messageAdd.wifi.001') }}</span>
      </el-col>
      <el-col :span="24"></el-col>
      <!-- 新增wifi列表 -->
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('message.systemMsg.NewWifiList') }}:</span>
        <el-button type="text" @click="openAddDialog">{{ $t("message.systemMsg.add") }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="w?.w?.length">
          <el-tag id="tag-box" v-for="(v, i) in w?.w" :key="i" closable @close="wifiInfohandleClose(i)">ssid:{{ v?.ssid?.length > 30 ? v?.ssid?.substring(0, 29) + "..." : v?.ssid }}</el-tag>
        </div>
      </el-col>

      <el-col :span="10" class="setting-box">
        <span class="setTitle"
          >{{ $t("message.systemMsg.powerSavingMode") }}:</span
        >
        <el-select size="medium" v-model="w.pm">
          <el-option
            :label="$t('message.systemMsg.powerSaving')"
            :value="0"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.fullPower')"
            :value="1"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.fullAttack')"
            :value="2"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.bandSelect") }}:</span>
        <el-select size="medium" v-model="w.fb">
          <el-option
            :label="$t('message.systemMsg.auto')"
            :value="0"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.fifhz')"
            :value="1"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.twohz')"
            :value="2"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle"
          >{{ $t("message.systemMsg.RoamingThreshold") }}:</span
        >
        <el-select size="medium" v-model="w.rs">
          <el-option label="-55" :value="55"></el-option>
          <el-option label="-60" :value="60"></el-option>
          <el-option label="-65" :value="65"></el-option>
          <el-option label="-70" :value="70"></el-option>
          <el-option label="-75" :value="75"></el-option>
          <el-option label="-80" :value="80"></el-option>
          <el-option label="-85" :value="85"></el-option>
          <el-option label="-90" :value="90"></el-option>
        </el-select>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle"
          >{{ $t("message.systemMsg.RoamingIncrement") }}:</span
        >
        <el-select size="medium" v-model="w.rc">
          <el-option label="2" :value="2"></el-option>
          <el-option label="3" :value="3"></el-option>
          <el-option label="5" :value="5"></el-option>
          <el-option label="10" :value="10"></el-option>
          <el-option label="15" :value="15"></el-option>
          <el-option label="20" :value="20"></el-option>
          <el-option label="25" :value="25"></el-option>
          <el-option label="30" :value="30"></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- Wi-Fi黑白名单 -->
    <el-row>
      <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.wifi.002') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t('messageAdd.wifi.003') }}:</span>
        <el-select size="medium" v-model="w.ri">
          <el-option :label="$t('messageAdd.wifi.004')" :value="0"></el-option>
          <el-option :label="$t('messageAdd.wifi.005')" :value="1"></el-option>
          <el-option :label="$t('messageAdd.wifi.006')" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="24"></el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.WhiteList") }}:</span>
        <el-button type="text" @click="openWhiteList">{{
          $t("message.systemMsg.add")
        }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box"  v-if="wDataClone.length > 0">
        <el-tag id="tag-box" v-for="(v, i) in wDataClone" :key="i">ssid:{{
            v.ssid.length > 30 ? v.ssid.substring(0, 29) + "..." : v.ssid
          }}</el-tag>
        </div>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">{{ $t("message.systemMsg.blacklist") }}:</span>
        <el-button type="text" @click="openBlackList">{{
          $t("message.systemMsg.add")
        }}</el-button>
      </el-col>
      <el-col :span="24">
        <div class="tags-box"  v-if="bDataClone.length > 0">
        <el-tag id="tag-box" v-for="(v, i) in bDataClone" :key="i">ssid:{{
            v.ssid.length > 30 ? v.ssid.substring(0, 29) + "..." : v.ssid
          }}</el-tag>
        </div>
      </el-col>
    </el-row>
    <!-- 白名单弹框 -->
    <el-dialog
      :title="$t('message.systemMsg.addWhitelist')"
      :visible.sync="whitelistDialogVisible"
      width="40%"
      @close="closeWhiteData"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        style="width: 100%">
        <el-button
          type="text"
          icon="el-icon-circle-plus-outline"
          @click="addwhitelist"
          >{{ $t("message.systemMsg.add") }}</el-button
        >
      </div>
      <el-table border :data="wData">
        <el-table-column
          prop="id"
          :label="$t('message.systemMsg.index')"
          width="80"
          type="index"
          align="center"
        />
        <el-table-column prop="packageName" align="center" label="SSID">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.ssid }}</span>
            <el-input
              v-show="scope.row.isEdit"
              v-model="scope.row.ssid"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.systemMsg.operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-circle-check"
              v-show="scope.row.isEdit"
              @click="okwhitelist(scope.row)"
              >{{ $t("common.save") }}</el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="editwhitelist(scope.row)"
              v-show="!scope.row.isEdit"
            >{{ $t("common.edit") }}</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="delwhitelist(scope.row)"
              v-show="!scope.row.isEdit"
            >{{ $t("common.delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeWhiteData">{{ $t("common.cancel")}}</el-button>
        <el-button type="primary" @click="savewhitelist">{{ $t("common.submit")}}</el-button>
      </span>
    </el-dialog>
    <!-- 黑名单弹框 -->
    <el-dialog
      :title="$t('message.systemMsg.addBlacklist')"
      :visible.sync="blacklistDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeBlackData"
    >
      <div>
        <el-button
          type="text"
          icon="el-icon-circle-plus-outline"
          @click="addblacklist"
          >{{ $t("message.systemMsg.add") }}</el-button
        >
      </div>
      <el-table border :data="bData">
        <el-table-column
          prop="id"
          :label="$t('message.systemMsg.index')"
          width="80"
          type="index"
          align="center"
        />
        <el-table-column prop="packageName" align="center" label="SSID">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.ssid }}</span>
            <el-input
              v-show="scope.row.isEdit"
              v-model="scope.row.ssid"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.systemMsg.operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-circle-check"
              v-show="scope.row.isEdit"
              @click="okblacklist(scope.row)"
              >{{ $t("common.save") }}</el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="editblacklist(scope.row)"
              v-show="!scope.row.isEdit"
            >{{ $t('common.edit') }}</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="delblacklist(scope.row)"
              v-show="!scope.row.isEdit"
            >{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBlackData">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveblacklist">{{ $t("common.submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增wifi弹框 -->
    <el-dialog
      title="添加Wi-Fi"
      :visible.sync="oneDialogVisible"
      width="40%"
      class="wifi-dialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="cancelWifiInfoToW"
    >
      <el-form
        label-width="150px"
        :rules="wifiRules"
        :model="wifiData"
        ref="addWifiForm"
        class="wifi-form"
      >
        <el-form-item label="SSID" prop="ssid">
          <el-input placeholder="SSID" v-model="wifiData.ssid"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.password')"
          prop="password"
          v-show="
            wifiData.securityType != 0 &&
            wifiData.eapMethod != 4 &&
            wifiData.eapMethod != 5 &&
            wifiData.eapMethod != 6
          "
        >
          <el-input
            :placeholder="$t('message.systemMsg.password')"
            v-model="wifiData.password"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.EncryptionType')"
          prop="securityType"
        >
          <el-select
            :placeholder="$t('message.systemMsg.selectSecurity')"
            v-model="wifiData.securityType"
          >
            <el-option
              :label="$t('message.systemMsg.switchSelect.null')"
              :value="0"
            ></el-option>
            <el-option label="WEP" :value="1"></el-option>
            <el-option label="WPA/WPA2 PSK" :value="2"></el-option>
            <el-option label="802.1*EAP" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.EPA')"
          v-show="wifiData.securityType == 3"
        >
          <el-select
            :placeholder="$t('message.systemMsg.EPA')"
            v-model="wifiData.eapMethod"
          >
            <el-option label="PEAP" :value="0"></el-option>
            <el-option label="TLS" :value="1"></el-option>
            <el-option label="TTLS" :value="2"></el-option>
            <el-option label="PWD" :value="3"></el-option>
            <el-option label="SIM" :value="4"></el-option>
            <el-option label="AKA" :value="5"></el-option>
            <el-option label="AKA'" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份认证1 -->
        <el-form-item
          :label="$t('message.systemMsg.Authentication')"
          v-show="
            wifiData.securityType == 3 &&
            (wifiData.eapMethod === 1 ||
              wifiData.eapMethod === 3 ||
              wifiData.eapMethod === 4 ||
              wifiData.eapMethod === 5 ||
              wifiData.eapMethod === 6)
          "
        >
          <el-select
            :placeholder="$t('message.systemMsg.Authentication')"
            v-model="wifiData.phase2"
          >
            <el-option label="MSCHAPV2" :value="3"></el-option>
            <el-option label="GTC" :value="4"></el-option>
            <el-option label="SIM" :value="5"></el-option>
            <el-option label="AKA" :value="6"></el-option>
            <el-option label="AKA'" :value="7"></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份认证2 -->
        <el-form-item
          :label="$t('message.systemMsg.Authentication')"
          v-show="
            wifiData.securityType == 3 &&
            (wifiData.eapMethod === 0 || wifiData.eapMethod === 2)
          "
        >
          <el-select
            :placeholder="$t('message.systemMsg.Authentication')"
            v-model="wifiData.phase2"
          >
            <el-option label="PAP" :value="1"></el-option>
            <el-option label="MSCHAP" :value="2"></el-option>
            <el-option label="MSCHAPV2" :value="3"></el-option>
            <el-option label="GTC" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.systemMsg.UseDeviceMac')">
          <el-select v-model="wifiData.isUseDeviceMac">
            <el-option
              :label="$t('message.systemMsg.trueUseDeviceMac')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.falseUseDeviceMac')"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.CA')"
          v-show="
            wifiData.securityType == 3 &&
            wifiData.eapMethod != 3 &&
            wifiData.eapMethod != 4 &&
            wifiData.eapMethod != 5 &&
            wifiData.eapMethod != 6
          "
        >
          <el-select
            :placeholder="$t('message.systemMsg.CA')"
            v-model="wifiData.caCertificate"
          >
            <el-option
              :label="$t('message.systemMsg.sysCertificate')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.NotVerify')"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.domainName')"
          v-show="
            wifiData.securityType == 3 &&
            wifiData.eapMethod != 3 &&
            wifiData.eapMethod != 4 &&
            wifiData.eapMethod != 5 &&
            wifiData.eapMethod != 6 &&
            wifiData.caCertificate
          "
        >
          <el-input
            :placeholder="$t('message.systemMsg.domainName')"
            v-model="wifiData.domainName"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.identity')"
          v-show="
            wifiData.securityType == 3 &&
            wifiData.eapMethod != 4 &&
            wifiData.eapMethod != 5 &&
            wifiData.eapMethod != 6
          "
        >
          <el-input
            :placeholder="$t('message.systemMsg.identity')"
            v-model="wifiData.identity"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.systemMsg.AnonymousIdentity')"
          v-show="
            wifiData.securityType == 3 &&
            wifiData.eapMethod != 3 &&
            wifiData.eapMethod != 4 &&
            wifiData.eapMethod != 5 &&
            wifiData.eapMethod != 6
          "
        >
          <el-input
            :placeholder="$t('message.systemMsg.AnonymousIdentity')"
            v-model="wifiData.anonymousIdentity"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('message.systemMsg.HiddenNetwork')">
          <el-select
            :placeholder="$t('message.systemMsg.HiddenNetwork')"
            v-model="wifiData.hidden"
          >
            <el-option
              :label="$t('message.systemMsg.true')"
              :value="true"
            ></el-option>
            <el-option
              :label="$t('message.systemMsg.false')"
              :value="false"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancelWifiInfoToW">{{ $t("message.setInfo.cancel") }}</el-button>
        <el-button type="primary" @click="addwifiInfoToW">{{ $t("message.setInfo.save")}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    wifi: {
      type: Object
    },
  },
  data() {
    return {
      oneDialogVisible: false, //新增wifi弹框
      whitelistDialogVisible: false, //白名单弹框
      blacklistDialogVisible: false, //黑名单弹框
      wData: [],
      wDataClone:[],
      bDataClone:[],
      bData: [],
      wifiData: {}, //添加WiFi表单
    };
  },
    computed:{
      w(){
      return this.wifi
      },
      wifiRules(){
        return {ssid: [
          {
            required: true,
            message: this.$t("message.messageMsg.InputSSID"),
            trigger: "change",
          },
        ],
        securityType: [
          {
            required: true,
            message: this.$t("message.messageMsg.InputSecurity"),
            trigger: "change",
          },
        ],
        password: [
          {
            min: 8,
            message: this.$t("message.info.pwdInfo"),
            trigger: "blur",
          },
        ],
      }
    }
    },
  watch:{
    // 监听wifi.sl的数据变化，并及时修改wData的数值
    'wifi.sl': {
      handler(newVal) {
        this.wData = newVal.map(item => ({ ssid: item, isEdit: false }));
        this.wDataClone= [...this.wData];
      },
     immediate:true
    },
    // 监听wifi.bl的数据变化，并及时修改bData的数值
    'wifi.bl': {
      handler(newVal) {
        this.bData= newVal.map(item => ({ ssid: item, isEdit: false }));
        this.bDataClone= [...this.bData];
      },
      immediate:true
    },
   // 监听 w 的变化，并通知父组件
   w: {
      handler(newVal) {
        this.$emit('update:wifi', newVal);
        this.$emit('update:config-wifi', newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {
    // 新增wifi弹框
    openAddDialog() {
      this.wifiData = {};
      this.oneDialogVisible = true;
    },
    // 取消保存
    cancelWifiInfoToW() {
      this.wifiData = {};
      this.oneDialogVisible = false;
      this.$refs.addWifiForm.clearValidate(); // 清除表单验证状态
    },
    // 保存添加wifi
    addwifiInfoToW() {
      this.$refs["addWifiForm"].validate((valid) => {
        if (valid) {
          this.w.w.push({...this.wifiData}); // 直接将wifiData对象添加到数组中
          this.oneDialogVisible=false;
          this.$message({
          message: this.$t('messageAdd.wifi.007'),
          type: 'success'
        });
      } else {
        // 如果验证不通过，显示错误信息或进行其他处理
        this.$message({
          message:  this.$t('messageAdd.wifi.008'),
          type: 'error'
        });
      }
      });
    },
    // 打开白名单
    openWhiteList() {
      // this.wData = JSON.parse(JSON.stringify(this.whiteList));
      this.whitelistDialogVisible = true;
    },
    addwhitelist() {
      this.wData.push({
        ssid: "",
        isEdit: true,
      });
    },
    editwhitelist(data) {
      data.isEdit = true;
    },
    okwhitelist(data) {
      if (data.ssid != "") {
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.ssidNoEmpty"),
          type: "warning",
        });
      }
    },
    delwhitelist(data) {
      let i = this.wData.indexOf(data);
      this.wData.splice(i, 1);
    },
    savewhitelist() {
      // 保存数据到父组件w的sl中
      if(this.wData.every(item => item.isEdit === false)){
        const newData=[];
        if(this.wData.length!=0){
          this.wData.map(item=>{
            newData.push(item.ssid);
          })
        }
        this.wDataClone=[...this.wData];
        this.w.sl=[...newData];
        this.whitelistDialogVisible = false;
      }else{
        this.$message.closeAll();
        this.$message.warning( this.$t('messageAdd.wifi.009'));
      }
    },
    closeWhiteData(){
      this.wData=[];
      this.wData=[...this.wDataClone];
      this.whitelistDialogVisible = false;
    },
    // 黑名单
    openBlackList() {
      // this.bData = JSON.parse(JSON.stringify(this.balckList));
      this.blacklistDialogVisible = true;
    },
    addblacklist() {
      this.bData.push({
        ssid: "",
        isEdit: true,
      });
    },
    editblacklist(data) {
      data.isEdit = true;
    },
    okblacklist(data) {
      if (data.ssid != "") {
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.ssidNoEmpty"),
          type: "warning",
        });
      }
    },
    delblacklist(data) {
      let i = this.bData.indexOf(data);
      this.bData.splice(i, 1);
    },
    cancelblacklist(data) {
      data.isEdit = false;
      data.ssid = "";
    },
    saveblacklist() {
      if(this.bData.every(item => item.isEdit === false)){
        const newData=[];
        if(this.bData.length!=0){
          this.bData.map(item=>{
            newData.push(item.ssid);
          })
        }
        this.bDataClone=[...this.bData];
        this.w.bl=[...newData];
        this.blacklistDialogVisible = false;
      }else{
        this.$message.closeAll();
        this.$message.warning( this.$t('messageAdd.wifi.009'));
      }
    },
    closeBlackData(){
      this.bData=[];
      this.bData=[...this.bDataClone];
      this.blacklistDialogVisible = false;
    },
    wifiInfohandleClose(index) {
      if (this.w.w.length > 0) {
        this.w.w.splice(index, 1);
      }
    },
  },
};
</script>
